export const TYPE_KEY = Symbol('resourceType');

export const TYPE_AS = (type) => {
    return (item) => {
        item[TYPE_KEY] = type;
        return item;
    };
};
